import type { ReactNode } from 'react';

export const symbol_shopping_bag_speed: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m758-140 6-50 3-26q3-26 8-64 2-21 4.5-39.5T784-350l3-26q3-26 8-64t8-64l3-26 16-130-64 520ZM211-80q-24 0-38.5-18T158-140h600l64-520H682l-11 90q-2 13-11.5 21.5T637-540q-12 0-20-9t-6-21l11-90H442l-11 90q-2 13-11.5 21.5T397-540q-12 0-20-9t-6-21l11-90H222q3-26 22-43t45-17h100l2-10q9-72 52.5-111T559-880q61 0 99.5 48.5T689-720h140q24 0 40 18t13 42l-64 520q-3 26-22 43t-45 17H211Zm238-640h180q5-39-17.5-69.5T552-820q-43 0-69.5 23.5T451-730l-2 10ZM230-250H90q-13 0-21.5-8.5T60-280q0-13 8.5-21.5T90-310h140q13 0 21.5 8.5T260-280q0 13-8.5 21.5T230-250Zm120-160H170q-13 0-21.5-8.5T140-440q0-13 8.5-21.5T170-470h180q13 0 21.5 8.5T380-440q0 13-8.5 21.5T350-410Z"
		/>
	</svg>
);
